import { Fragment, PureComponent, ReactNode } from "react";
import { ProgressBar } from "@App/Components/common/ProgressBar";
import { TFunction, withTranslation } from "react-i18next";

type FunnelHeaderProps = {
  heading: string;
  step: number;
  maxSteps: number;
  subheading: string;
  description?: string;
  t: TFunction; // translation method from withTranslation HOC from i18next
};

export class FunnelHeaderComponent extends PureComponent<FunnelHeaderProps> {
  static defaultProps = {
    disabled: false,
  };

  render(): ReactNode {
    const { heading, step, maxSteps, subheading, description } = this.props;

    return (
      <Fragment>
        <h3 className="text-primary text-3xl font-serif font-weight-normal mb-5">{heading}</h3>
        {/*<div className="text-sm mb-5">{t('In wenigen Schritten zur Werkstattuebersicht')}</div>*/}
        <div className="w-full md:w-1/3">
          <ProgressBar currentStep={step} steps={maxSteps} />
        </div>
        <h6
          className="
                    w-full md:w-1/2
                    text-2xl font-serif
                    mb-3"
        >
          {subheading}
        </h6>
        {description && (
          <div
            className="
                                w-full md:w-1/2
                                text-sm text-neutral-700
                                mb-8
                            "
          >
            <i>{description}</i>
          </div>
        )}
      </Fragment>
    );
  }
}

export const FunnelHeader = withTranslation()(FunnelHeaderComponent);
